import { useEffect } from "react"
import { useToast } from "@/hooks/use-toast"
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast"

export function Toaster() {
  const { toasts, dismiss } = useToast()

  // Add global click listener to dismiss toasts when clicking anywhere
  useEffect(() => {
    const handleGlobalClick = () => {
      if (toasts.length > 0) {
        dismiss() // Dismiss all toasts
      }
    }

    // Only add listener if there are active toasts
    if (toasts.length > 0) {
      document.addEventListener('click', handleGlobalClick)
      document.addEventListener('touchstart', handleGlobalClick) // For mobile
      
      return () => {
        document.removeEventListener('click', handleGlobalClick)
        document.removeEventListener('touchstart', handleGlobalClick)
      }
    }
  }, [toasts.length, dismiss])

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        return (
          <Toast key={id} {...props}>
            <div className="grid gap-1">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && (
                <ToastDescription>{description}</ToastDescription>
              )}
            </div>
            {action}
            <ToastClose />
          </Toast>
        )
      })}
      <ToastViewport />
    </ToastProvider>
  )
}
